import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output
} from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageHelpers } from '../../helpers';
import { AnalyticsService } from '../../services';
import * as moment from 'moment';

@Component({
  selector: 'app-time-graph',
  templateUrl: './app-time-graph.component.html',
  styleUrls: ['./app-time-graph.component.scss'],
  providers: [LocalStorageHelpers]
})
export class AppTimeGraphComponent implements OnInit, OnChanges {
  public brandPrimary = '#F77D2D';
  public brandSuccess = '#22B573';

  @Input() type: string;
  @Input() subset: number;
  @Input() id: number;
  @Input() year: number = null;
  @Output() ready: EventEmitter<boolean> = new EventEmitter<boolean>(true);

  public config = {
    dataset1: [],
    dataset2: [],
    dataset3: [],
    title: '',
    label1: '',
    label2: '',
    ctrLabel: 'CTR',
    start: new Date(),
    end: new Date(),
    chartElements: 0,
    navigate_label: 'Event'
  };

  public loading = true;
  public chartElements: number;
  public chartData1: Array<number> = [];
  public chartData2: Array<number> = [];
  public chartData3: Array<number> = [];
  public chartLabels: Array<any>;
  private sumTotalData1 = 0;
  private sumTotalData2 = 0;
  private threshold: number;
  public chartData: Array<any> = [];
  public chartOptions: any = {};
  public ctrData;
  public monthly_percentage;
  public sumData1;
  public sumData2;
  public title;

  public noResults = false;
  public chartColours: Array<any> = [
    {
      // brandInfo
      backgroundColor: 'transparent',
      borderColor: this.brandPrimary,
      pointHoverBackgroundColor: '#fff',
      pointBackgroundColor: this.brandPrimary
    },
    {
      // brandSuccess
      backgroundColor: 'transparent',
      borderColor: this.brandSuccess,
      pointHoverBackgroundColor: '#fff',
      pointBackgroundColor: this.brandSuccess
    },
    {
      backgroundColor: 'transparent',
      borderColor: 'rgba(200, 200, 200, .7)',
      pointHoverBackgroundColor: '#fff'
    }
  ];
  public chartLegend = false;
  public chartType = 'line';

  constructor(
    private analyticsService: AnalyticsService,
    private router: Router
  ) {}

  ngOnInit(): void {}

  showCtr() {
    return this.ctrData >= 0;
  }

  populateDatasets() {
    // console.log('Graph Config', this.config);
    // console.log('Type:', this.type);
    // console.log('Subset:', this.subset);
    const that = this;
    this.chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      cubicInterpolationMode: 'default',
      layout: {
        padding: {
          left: 0,
          right: 0,
          top: 10,
          bottom: 0
        }
      },
      tooltips: {
        mode: 'index',
        intersect: false
      },
      hover: {
        mode: 'index',
        intersect: false
      },
      scales: {
        xAxes: [
          {
            drawBorder: true,
            gridLines: {
              drawOnChartArea: true
            },
            ticks: {
              fontSize: 16,
              padding: 20,
              autoSkip: true,
              callback: function(value: any, index, values) {
                return (
                  moment(value).format('DD MMM HH:mm') +
                  '-' +
                  moment(value)
                    .add(1, 'hour')
                    .format('HH:mm')
                );
              }
            }
          }
        ],
        yAxes: [
          {
            type: 'linear',
            maxBarThickness: 100,
            gridLines: {
              display: false,
              drawOnChartArea: true
            },
            display: this.subset === 2 || this.subset === 0,
            position: 'right',
            id: 'y-axis-2',
            scaleLabel: {
              display: true,
              labelString: this.config.label2,
              fontColor: this.brandSuccess,
              fontSize: 18
            },
            ticks: {
              autoSkip: true,
              padding: 10,
              beginAtZero: true,
              callback: function(value: any) {
                if (Math.floor(value) === value) {
                  return value;
                }
              }
            }
          },
          {
            type: 'linear',
            gridLines: {
              display: false,
              drawOnChartArea: true
            },
            // stacked: true,
            display: true,
            position: 'left',
            id: 'y-axis-1',
            // offset: true,
            scaleLabel: {
              display: true,
              labelString: this.config.label1,
              fontColor: this.brandPrimary,
              fontSize: 18
            },
            ticks: {
              // suggestedMin: -0.1,
              autoSkip: true,
              padding: 10,
              beginAtZero: true,
              callback: function(value: any) {
                if (Math.floor(value) === value) {
                  return value;
                }
              }
            }
          }
        ]
      },
      elements: {
        line: {
          borderWidth: 2
        },
        point: {
          radius: 1,
          hitRadius: 8,
          hoverRadius: 8,
          hoverBorderWidth: 3
        }
      },
      legend: {
        display: false
      }
    };
    this.chartData1 = [];
    this.chartData2 = [];
    this.chartData3 = [];

    this.chartElements = this.getChartElements();
    this.chartLabels = this.getChartLabels();

    this.chartData1 = this.populateChartData(this.chartLabels); // array getDailyValue from chartLabels
    console.log(this.chartData);

    this.chartData1.forEach(data => {
      if (data) {
        this.noResults = false;
      }
    });
    this.chartData2.forEach(data => {
      if (data) {
        this.noResults = false;
      }
    });

    // Set CTR data
    if (this.subset === 0) {
      if (this.sumTotalData1 < this.sumTotalData2) {
        this.ctrData = Math.floor(
          (this.sumTotalData1 / this.sumTotalData2) * 100
        );
      }
    }

    this.monthly_percentage = Math.floor(
      ((this.sumTotalData1 - this.threshold) * 100) / this.threshold
    );

    this.chartData[0] = {
      data: this.chartData1,
      label: this.config.label1,
      yAxisID: 'y-axis-1',
      spanGaps: true,
      lineTension: 0.1
    };
    this.chartData[1] = {
      data: this.chartData2,
      label: this.config.label2,
      yAxisID: 'y-axis-2', // 'y-axis-1' PER SCALA DOPPIA
      spanGaps: true,
      lineTension: 0.1
    };
    this.chartData[2] = [];
  }

  ngOnChanges() {
    this.reset();
    this.setup();
  }

  reset() {
    this.config.dataset1 = [];
    this.config.dataset2 = [];
    this.config.dataset3 = [];
    this.config.title = '';
    this.config.label2 = '';
    this.config.ctrLabel = 'CTR';
    this.config.start = new Date();
    this.config.end = new Date();
    this.sumData1 = 0;
    this.sumTotalData1 = 0;
    this.sumData2 = 0;
    this.sumTotalData2 = 0;
    this.noResults = true;
  }

  getChartElements() {
    const start = moment(this.config.start);
    const end = moment(this.config.end);
    const hoursRange = end.diff(start, 'hours');
    // console.log('Hours between event start and last checkIn (chartElements)', hoursRange);
    return hoursRange;
  }

  getChartLabels() {
    const dates = [];
    const totalDates = this.getChartElements();
    for (let i = 0; i <= totalDates; i++) {
      const date = moment(this.config.start)
        .add(i, 'hours')
        .startOf('hour')
        .toDate();
      dates.push(date);
    }
    // console.log('chartLabels', dates);
    return dates;
  }

  dateIsFuture(date) {
    return moment().diff(date, 'minutes') < 0;
  }

  populateChartData(chartLabels) {
    const countsByDate = [];
    for (let i = 0; i < chartLabels.length; i++) {
      let result = 0;
      for (let j = 0; j < this.config.dataset1.length; j++) {
        const datasetDate = moment(this.config.dataset1[j].date);
        if (moment(chartLabels[i]).isSame(moment(datasetDate), 'hour')) {
          result++;
          this.sumTotalData1 += result;
        }
        if (this.dateIsFuture(moment(chartLabels[i]).toDate())) {
          result = null;
        }
      }
      countsByDate.push(result);
    }
    // console.log('countsByDate', countsByDate);
    return countsByDate;
  }

  setup() {
    this.loading = true;
    this.ready.emit(false);
    let apiCall, subscription;

    this.title = 'Event analytics';
    apiCall = this.analyticsService.getEventsGraph(this.id, null, this.year);
    subscription = apiCall.subscribe(results => {
      console.log('getEventsGraph', results);
      this.reset();
      this.config.dataset1 = results['check_ins'];
      this.config.label1 = 'check-ins during event';
      this.config.start = results.start;
      this.config.end = results.end;
      this.finalizeEvent(subscription);
    });
  }

  finalizeEvent(subscription) {
    this.populateDatasets();
    subscription.unsubscribe();
    this.loading = false;
    this.ready.emit(true);
  }

  chartClicked() {}

  navigate() {
    this.router.navigate(['/events']);
  }
}
